import './index.scss';
import logoDark from '../../assets/logo-dark.svg'
import logoLight from '../../assets/logo-light.svg'
import { useWindowScroll } from 'react-use';
import { useTheme } from '../ThemeProvider'
import { useMemo, useState } from 'react'
import { Link } from "react-scroll";

const MENU = [
  {
    name: 'Home',
    path: 'home'
  },
  {
    name: 'About',
    path: 'about'
  },
  {
    name: 'Skill',
    path: 'skill'
  },
  {
    name: 'Experience',
    path: 'experience'
  }
]

function Header() {

  const { theme, setTheme } = useTheme();
  const {y} = useWindowScroll();
  const [title, setTitle] = useState('home')
  
  const isDarkMode = useMemo(() => theme==='dark', [theme])
  const iconMode = useMemo(() => isDarkMode?'fill':'outline', [isDarkMode])
  const logo = useMemo(()=>(isDarkMode?logoLight:logoDark), [isDarkMode])
  const [open, setOpen] = useState(false)


  const toggleMenu = () => {
    setOpen(!open)
  }

  const handleSetActive = (to) => {
    setTitle(to)
    setOpen(false)
  }


  const renderMenu = () => MENU.map(({name, path}, idx)=>(
    <div className='menu' key={name} style={{'--i':idx+1}}>
      <svg height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
        <rect className="line" height="100%" width="100%" />
      </svg>
      <Link smooth spy to={path} activeClass='active' onSetActive={handleSetActive}>{name}</Link>
  </div>
  ))


  return (
    <header className={`${y>10?'scroll':'' }`}>
      <div className='header'>
      <div className='content'>
        <img src={logo} alt="logo" className='logo'/>
        <div className='title'>{title}</div>
        <div className='nav'>
          <nav className={`${open?'visible':''}`}>
            {renderMenu()}
          </nav>
          <div className='mode' onClick={()=>setTheme(isDarkMode?'light':'dark')}>
          {isDarkMode?'🌞':'🌙'}
          </div>
          <i className={`iconfont icon-menu-${iconMode}`} onClick={toggleMenu}></i>
        </div>
      </div>
      </div>
    </header>
  );
}
export default Header;